(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const show = (dialog, index) => {
      const slides = dialog.querySelectorAll('[data-ig-slide]');
      if (!slides.length) return;
      const next = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== next;
      });
      dialog.dataset.igCurrent = String(next);
    };

    // Capture phase: pick the photo before the shared dialog handler opens the lightbox
    document.addEventListener(
      'click',
      (event) => {
        const post = event.target.closest('[data-ig-index]');
        if (post) {
          const dialog = document.getElementById(post.dataset.dialogOpen);
          if (dialog) show(dialog, Number(post.dataset.igIndex));
          return;
        }
        const step = event.target.closest('[data-ig-prev], [data-ig-next]');
        if (step) {
          const dialog = step.closest('[data-ig-lightbox]');
          show(dialog, Number(dialog.dataset.igCurrent || 0) + (step.matches('[data-ig-next]') ? 1 : -1));
        }
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      const dialog = document.querySelector('[data-ig-lightbox][open]');
      if (!dialog || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
      show(dialog, Number(dialog.dataset.igCurrent || 0) + (event.key === 'ArrowRight' ? 1 : -1));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
